"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionApi = void 0;
var Cookies = __importStar(require("js-cookie"));
var http_client_1 = require("http-client");
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(message, response) {
        var _this = _super.call(this, message) || this;
        _this.response = response;
        return _this;
    }
    return ResponseError;
}(Error));
var SessionApi = /** @class */ (function () {
    function SessionApi(cookieKey, railsUrl) {
        var _this = this;
        this.BASE_URL = '/api/v1';
        // N.B. this is a function because `Cookies.get` can change
        // during runtime, we don't want to use the original (or nonexistant)
        // one from JS-load time
        this.commonStack = function () {
            return (0, http_client_1.createStack)((0, http_client_1.init)('credentials', 'include'), (0, http_client_1.accept)('application/json'), (0, http_client_1.header)('Content-Type', 'application/json'), (0, http_client_1.header)('X-CSRF-Token', Cookies.get(cookieKey)), (0, http_client_1.base)(railsUrl));
        };
        // HACK: ES5 ts target mangles the `this` binding
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(this.__proto__).forEach(function (key) {
            _this[key] = _this[key].bind(_this);
        });
    }
    SessionApi.prototype.doWebGet = function (url) {
        return (0, http_client_1.createFetch)(this.commonStack())(url);
    };
    SessionApi.prototype.doWebPost = function (url, jsonParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack(), (0, http_client_1.method)('POST'), (0, http_client_1.json)(jsonParams));
        return (0, http_client_1.createFetch)(stack)(url);
    };
    SessionApi.prototype.doWebPut = function (url, jsonParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack(), (0, http_client_1.method)('PUT'), (0, http_client_1.json)(jsonParams));
        return (0, http_client_1.createFetch)(stack)(url);
    };
    SessionApi.prototype.doWebDelete = function (url) {
        return (0, http_client_1.createFetch)(this.commonStack(), (0, http_client_1.method)('DELETE'))(url);
    };
    SessionApi.prototype.doWebApiGet = function (url, getParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack());
        if (getParams) {
            stack = (0, http_client_1.createStack)(stack, (0, http_client_1.params)(getParams));
        }
        return (0, http_client_1.createFetch)(stack)("".concat(this.BASE_URL).concat(url));
    };
    SessionApi.prototype.handleResponse = function (res) {
        if (res.ok) {
            return res.json();
        }
        throw new ResponseError("".concat(res.status, " ").concat(res.statusText), res);
    };
    // Either email+password, googleIDToken, or email+password+facebookIDToken is required
    //
    // If email+password+facebookIDToken is provided then web will authenticate using
    // the facebook_authenticatable warden strategy. The facebookIDToken should be the accessToken
    // provided from Facebook client-side auth
    // https://developers.facebook.com/docs/facebook-login/web
    //
    // If email+password is provided then web will authenticate using
    // the database_authenticatable warden strategy.
    //
    // If googleIDToken is provided the google_authenticatable strategy is used to authenticate.
    // The googleIDToken should be the OIDC token obtained from Google client-side auth
    // https://developers.google.com/identity/protocols/oauth2/openid-connect#obtainuserinfo
    //
    // For more details on authentication via Web check the devise configuration for the
    // Human model: https://github.com/opendoor-labs/web/blob/7fbaffaf02d03cd75a8ad57c2f1b400dacbb2782/app/models/human.rb
    SessionApi.prototype.logIn = function (email, password, googleIDToken, facebookIDToken) {
        return this.doWebPost('/login', {
            human: { email: email, password: password },
            google_id_token: googleIDToken,
            facebook_id_token: facebookIDToken,
        }).then(this.handleResponse);
    };
    SessionApi.prototype.requestHumanStatus = function (email) {
        return this.doWebApiGet("/humans/status?email=".concat(encodeURIComponent(email))).then(this.handleResponse);
    };
    SessionApi.prototype.requestResetPassword = function (email) {
        return this.doWebPost("".concat(this.BASE_URL, "/humans/reset-password"), { email: email });
    };
    // Either email+password, googleIDToken, or email+password+facebookIDToken is required
    //
    // If email+password+facebookIDToken is provided then web will authenticate using
    // the facebook_authenticatable warden strategy. The facebookIDToken should be the accessToken
    // provided from Facebook client-side auth
    // https://developers.facebook.com/docs/facebook-login/web
    //
    // If email+password is provided then web will authenticate using
    // the database_authenticatable warden strategy.
    //
    // If googleIDToken is provided the google_authenticatable strategy is used to authenticate.
    // The googleIDToken should be the OIDC token obtained from Google client-side auth
    // https://developers.google.com/identity/protocols/oauth2/openid-connect#obtainuserinfo
    // If a user already exists with the provided email then the user will be logged in.
    //
    // For more details on authentication via Web check the devise configuration for the
    // Human model: https://github.com/opendoor-labs/web/blob/7fbaffaf02d03cd75a8ad57c2f1b400dacbb2782/app/models/human.rb
    SessionApi.prototype.register = function (email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword) {
        return this.doWebPost('/register', {
            email: email,
            full_name: name,
            primary_phone: phone,
            password: password,
            google_id_token: googleIDToken,
            facebook_id_token: facebookIDToken,
            passwordless_token: passwordlessToken,
            has_generated_password: hasGeneratedPassword,
        }).then(this.handleResponse);
    };
    SessionApi.prototype.logOut = function () {
        return this.doWebDelete('/logout');
    };
    SessionApi.prototype.fetchSessionInfo = function () {
        return this.doWebGet('/session/info').then(function (res) { return res.json(); });
    };
    SessionApi.prototype.updateHumanInfo = function (humanId, password, name, phone) {
        return this.doWebPut("".concat(this.BASE_URL, "/humans/").concat(humanId), {
            full_name: name,
            primary_phone: phone,
            current_password: password,
        }).then(function (res) { return res.json(); });
    };
    return SessionApi;
}());
exports.SessionApi = SessionApi;
exports.default = SessionApi;
//# sourceMappingURL=session.js.map